import styled from "styled-components";

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    padding: 20px 20px 20px 5px;
`;